export default __webpack_public_path__ + "locales/si/ConvertDialog.json?hash=1a435edf123764be874622eff5b8f1a8";